export const isWonOpportunity = (line) => line.status === 'WON' || line.salesStage === '08 - Won';

export const revenueLineTitle = (line) => {
    const name = line.projectNumber || line.quoteNumber || line.opportunityName || 'Revenue line';
    const amount = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' })
        .format(line.amount ?? line.weightedAmount ?? 0);
    return [name, amount].filter(Boolean).join(' - ');
};

export const formatEvents = (lines) => lines
    .filter(line => line.shipDate && !Number.isNaN(new Date(line.shipDate).getTime()))
    .map(line => ({
        id: String(line.lineId),
        title: revenueLineTitle(line),
        start: new Date(line.shipDate).toISOString().slice(0, 10),
        allDay: true,
        ...(isWonOpportunity(line) ? { backgroundColor: '#2e7d32', borderColor: '#2e7d32' } : {}),
        classNames: [isWonOpportunity(line) && 'shipping-won', line.shipDate.slice(0, 10) < new Date().toISOString().slice(0, 10) && 'shipping-overdue'].filter(Boolean),
        extendedProps: {
            opportunityId: line.opportunityId,
            preview: [line.customerName, line.opportunityName, line.lineComments, revenueLineTitle(line), `Ship date: ${line.shipDate.slice(0, 10)}`,
                line.shipDate.slice(0, 10) < new Date().toISOString().slice(0, 10) && 'Overdue: ship date has passed'].filter(Boolean).join('\n'),
        },
    }));
